import { bl_fi_mst_entity_label_link_RowClass } from '../../../dbschema/bl_fi_mst_entity_label_link.model';
import {BaseContainerModel} from '../../base-container.model';

export class EntityLabelLinkContainerModel extends BaseContainerModel {
  bl_fi_mst_entity_label_link: bl_fi_mst_entity_label_link_RowClass = new bl_fi_mst_entity_label_link_RowClass();
}
